import { ChevronDownIcon } from "../../../../icons";
import { Color } from "../../../../theme";
import { transparentize } from "polished";
import { DropdownIndicatorProps, GroupBase, components } from "react-select5";

export function DropdownIndicatorComponent<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: DropdownIndicatorProps<Option, IsMulti, Group> & { icon?: React.ReactNode }) {
  const { icon, ...rest } = props;
  return (
    <components.DropdownIndicator {...rest}>
      {icon ? (
        icon
      ) : (
        <ChevronDownIcon
          style={{
            width: "14px",
            height: "14px",
            transform: props.selectProps.menuIsOpen ? "rotate(-180deg)" : "rotate(0deg)",
            transition: "0.2s ease",
            fill: props.selectProps.isDisabled
              ? transparentize(0.5, Color.Body)
              : Color.Body,
            stroke: props.selectProps.isDisabled
              ? transparentize(0.5, Color.Body)
              : Color.Body
          }}
        />
      )}
    </components.DropdownIndicator>
  );
}
